import React from "react";
import { FieldArray, useFormikContext, getIn } from "formik";
import { Grid, Button, TextField } from "@material-ui/core";
import { ErrorCommon, SelectField, TextFieldCommon } from "../../../../../../components/formikFormInputs";
import { Label } from "../../../../../../components/formInputs";

export const yearOptions = [
    { id: 1, value: 1, name: "1 year" },
    { id: 2, value: 2, name: "2 years" },
    { id: 3, value: 3, name: "3 years" },
    { id: 4, value: 4, name: "4 years" },
    { id: 5, value: 5, name: "5 years" },
    { id: 6, value: 6, name: "6+ years" },
];

export const politicalRelationsInitValue = {
        fullName: "",
        title: "",
        organization: "",
        cityState: "",
        yearsHeld: undefined,
    }

const PoliticalRelationFields = () => {
    const { values, errors, touched, handleChange, handleBlur } =
            useFormikContext<any>();
    console.log("values", values);
    return (
            <FieldArray name="politicalRelations">
                {({ push, remove }) => (
                        <>
                            {values.politicalRelations && values.politicalRelations.map((item: any, index: number) => {
                                const fieldObj = [
                                    {
                                        id: `politicalRelations[${index}].fullName`,
                                        name: `politicalRelations[${index}].fullName`,
                                        value: getIn(values, `politicalRelations[${index}].fullName`) ,
                                        label: <Label label="Full Name of Person Holding the Role" required />,
                                        component: TextField,
                                        variant: "outlined",
                                    },
                                    {
                                        id: `politicalRelations[${index}].title`,
                                        name: `politicalRelations[${index}].title`,
                                        value: getIn(values, `politicalRelations[${index}].title`) ,
                                        label: <Label label="Title of the Role Held" required />,
                                        component: TextField,
                                        variant: "outlined",
                                    },
                                    {
                                        id: `politicalRelations[${index}].organization`,
                                        name: `politicalRelations[${index}].organization`,
                                        value: getIn(values, `politicalRelations[${index}].organization`),
                                        label: <Label label="Name of Business / Organization" required />,
                                        component: TextField,
                                        variant: "outlined",
                                    },
                                    {
                                        id: `politicalRelations[${index}].cityState`,
                                        name: `politicalRelations[${index}].cityState`,
                                        value: getIn(values, `politicalRelations[${index}].cityState`),
                                        label: <Label label="City and State of Business / Organization" required />,
                                        component: TextField,
                                        variant: "outlined",
                                    },
                                    {
                                        id: `politicalRelations[${index}].yearsHeld`,
                                        name: `politicalRelations[${index}].yearsHeld`,
                                        value: getIn(values, `politicalRelations[${index}].yearsHeld`) ,
                                        label: <Label label="Years Held in Role" required />,
                                        component: SelectField,
                                        options: yearOptions,
                                        variant: "outlined",
                                    },
                                ];

                                return (

                                            <Grid container className={"mb10"} spacing={2}>
                                                {fieldObj.map((fieldItem, i) => (
                                                        <Grid item xs={12} md={6} key={i}>
                                                            <TextFieldCommon
                                                                    {...fieldItem}
                                                                    values={values}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                            />

                                                            {/* Error display just like your example */}
                                                            <ErrorCommon
                                                                    name={fieldItem.name}
                                                                    errors={errors}
                                                                    touched={touched}
                                                            />
                                                        </Grid>
                                                ))}
                                                <span className="hLine" />
                                                {/* Remove Button */}

                                            </Grid>
                                );
                            })}
                            {/* remove last index*/}
                            {values.politicalRelations && values.politicalRelations.length > 1 &&<Button
                                    variant="text"
                                    color="primary"
                                    onClick={() => remove(values.politicalRelations.length -1)}
                            >
                                Remove
                            </Button>}
                            {/* Add Another */}
                            <Button
                                    variant="text"
                                    color="primary"
                                    className="floatRight"
                                    disabled={values.politicalRelations && values.politicalRelations.length > 4}
                                    onClick={() =>
                                            push(politicalRelationsInitValue)
                                    }
                            >
                                + Add Another
                            </Button>
                        </>
                )}
            </FieldArray>
    );
};

export default PoliticalRelationFields;
